module.exports = ".item-list:hover {\n  cursor: pointer; }\n"